import { Expose, Transform, Type } from 'class-transformer'

import { Base } from './Base'
import { Container } from './Container'
import { Product } from './Product'
import { Shipment } from './Shipment'
import { Sku } from './Sku'

export class ShipmentUnit extends Base {
  @Expose({ name: 'sku' })
  @Transform(({ sku }) => sku?.guid)
  guid: string = ''

  @Type(() => Shipment)
  shipment?: Shipment

  @Type(() => Product)
  product?: Product

  @Type(() => Sku)
  sku?: Sku

  @Type(() => Container)
  container?: Container

  @Expose({ name: 'num_units' })
  numUnits?: string
}
